import { useEffect, useState } from 'react';
import type { DietPlanApi } from '../api/dietPlanApi';
import type { Food, SlotKey } from '../types';

/** Debounced backend food search. Empty query → backend returns "often used at this slot". */
export function useFoodSearch(api: DietPlanApi, q: string, slot: SlotKey, enabled: boolean) {
  const [st, set] = useState<{ list: Food[]; loading: boolean; error: Error | null }>({ list: [], loading: false, error: null });
  useEffect(() => {
    if (!enabled) return;
    const ac = new AbortController();
    set(s => ({ ...s, loading: true, error: null }));
    const t = window.setTimeout(() => {
      api.searchFoods(q.trim(), slot, ac.signal).then(list => !ac.signal.aborted && set({ list, loading: false, error: null })).catch(error => !ac.signal.aborted && set({ list: [], loading: false, error }));
    }, q ? 250 : 0);
    return () => { window.clearTimeout(t); ac.abort(); };
  }, [api, q, slot, enabled]);
  return st;
}
